import {Stack, Table, TableRow, Typography} from '@mui/material';
import {FC} from 'react';
import {TableVirtuoso} from 'react-virtuoso';
import {usePrimaryChartsDataStore} from '../../store/usePrimaryChartsDataStore';
import {useRequestMapStore} from '../../store/useRequestMapStore';
import {FallbackWithChildren} from '../FallbackWithChildren';
import {renderContractRow, renderTableHeader} from './helpers';
import {DashboardContractData} from '../../../../../../shared/types/api-v2.types';
import {STYLES} from './styles';
import {useSortContracts} from './use-sort-contracts.hook';

export const ContractsList: FC = () => {
  const data = usePrimaryChartsDataStore((s) => s.contracts);
  const isLoading = usePrimaryChartsDataStore((s) => s.isLoading);
  const setSelectedContractId = useRequestMapStore((s) => s.setSelectedContractId);
  const {sortedContracts, sortField, sortOrder, handleSort} = useSortContracts(data.contracts || []);

  const handleRowClick = ({contract}: DashboardContractData) => {
    if (!contract?.id) return;
    setSelectedContractId(contract.id);
  };

  return (
    <Stack sx={STYLES.root}>
      <FallbackWithChildren isLoading={isLoading}>
        <Typography sx={STYLES.chartTitle}>Список контрактов</Typography>
        <TableVirtuoso
          style={STYLES.tableRoot}
          totalCount={sortedContracts?.length}
          data={sortedContracts}
          fixedHeaderContent={renderTableHeader({
            onSort: handleSort,
            activeField: sortField,
            activeOrder: sortOrder,
          })}
          itemContent={renderContractRow}
          components={{
            Table: (p) => <Table {...p} sx={STYLES.table} />,
            TableRow: (p) => <TableRow {...p} hover onClick={handleRowClick.bind(null, p.item)} />,
          }}
        />
      </FallbackWithChildren>
    </Stack>
  );
};
